<template>
    <div :class="classe" v-if="tableData" style="margin-bottom: 2em">
        
        <div class="table-scroll">
            <table v-if="tableData.data">
                <thead>
                    <tr>
                        <td class="fixed-header" v-for="header in tableData.headers">{{header}}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="data in tableData.data" :style="getStyle(data)">
                        <td v-for="value in data[0]" v-html="value"> </td>
                    </tr>
                </tbody>
            </table>

            <div v-else class="text-center">
                <span>Não há dados para exibir...</span>
            </div>

        </div>

        <div v-if="tableData.data" v-b-toggle="'expand-table-1'" class="btn-expand" @click="toggleChart">
            <i class="icon-visualizar-graficos"></i>
            <span>{{showChart ? 'Ocultar gráfico' : 'Visualizar gráfico'}}</span>
        </div>
    </div>
</template>

<style>
    .fixed-header {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 5;
        font-weight: 700;
    }

    table td {
        font-weight: inherit;
    }

    .table-scroll table tr td:first-child {
        text-align: left;
        width: 200px;
    }
</style>

<script>
    export default {
        name: "c-tabela",
        props:{
            title: String,
            classe: String,
            tableData: {
                headers: Array,
                data: Array
            }
        },
        data() {
            return {
                showChart: false
            }
        },
        methods: {
            toggleChart()
            {
                this.showChart = !this.showChart;
                this.$emit('toggleChart', this.showChart);
            },
            getStyle(data)
            {
                return typeof data[1] !== 'undefined' ?  'font-weight: 700; background-color: ' + data[1] : 'background-color: #FFFFFF';
            }
        },
    }
</script>
